/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/views/layouts/index'),
    redirect: '/home',
    meta: {
      title: '立项查询宝',
      keepAlive: false
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/projectQuery/index'),
        meta: { title: '立项查询宝', keepAlive: false, TabbarShow: false },
      },
    ]
  }
]
